import { render, staticRenderFns } from "./SettlementHouseholdModal.vue?vue&type=template&id=63e71226"
import script from "./SettlementHouseholdModal.vue?vue&type=script&lang=js"
export * from "./SettlementHouseholdModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports